/**
 * The emitter in this file is effectively forked from tiny-emitter:
 * https://github.com/scottcorgan/tiny-emitter/
 * which is under the MIT license:
 * https://github.com/scottcorgan/tiny-emitter/blob/master/LICENSE
 *
 * The code was small enough that it made more sense to just copy it locally
 * and make edits to it to fit our needs more closely
 */

export class Emitter {
    constructor() {}
    on(name, callback, ctx) {
        const e = this.e || (this.e = {});

        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });

        return this;
    }
    once(name, callback, ctx) {
        const self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }

        listener._ = callback;
        return this.on(name, listener, ctx);
    }

    emit(name) {
        const data = [].slice.call(arguments, 1);
        const evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        let i = 0;
        const len = evtArr.length;

        for (i; i < len; i++) {
            evtArr[i].fn.apply(evtArr[i].ctx, data);
        }

        return this;
    }

    off(name, callback) {
        const e = this.e || (this.e = {});
        const evts = e[name];
        const liveEvents = [];

        if (evts && callback) {
            for (let i = 0, len = evts.length; i < len; i++) {
                if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
            }
        }

        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

        liveEvents.length ? (e[name] = liveEvents) : delete e[name];

        return this;
    }
}

export const GlobalEventBus = new Emitter();
